import { FileData } from '../file-uploader/file-uploader.interface';

/* eslint-disable @typescript-eslint/naming-convention */
export interface NotesOptions {
    data?: any[];
    dataUrl: string;
    module: string;
    moduleUID: string;
    extraClass?: string;
    lazyLoad?: boolean;
    disableAPICall?: boolean;
    params?: any;
    config: NotesConfig;
    fileUploaderOptions?: FileData;
    defaultAssociatedModuleDetails: any;
    trackEventOptions?: any;
}

export interface NotesConfig {
    enableNewNote: boolean;
    enableNewAssociation: boolean;
    showNotifyUsers: boolean;
    attachments: {
        isEnabled: boolean;
        attachmentType?: string;
        isGridLayout?: boolean;
    };
    enablePrivacy: boolean;
    showUserProfile: boolean;
    sortOptions?: {
        isEnabled: boolean;
    };
    editorOptions?: {
        quickCreate: boolean;
        allowMentions?: boolean;
    };
    menuOptions?: {
        deleteOnly: boolean;
    };
    renderSmallScreen?: boolean;
    initUponFocus?: boolean;
}

export enum AttachmentType {
    TEXT = 'TEXT',
    AUDIO = 'AUDIO',
    VIDEO = 'VIDEO',
    IMAGE = 'IMAGE',
    DOCUMENT = 'DOCUMENT'
}

export enum NoteVisibilityType {
    INTERNAL = 'INTERNAL',
    PRIVATE = 'PRIVATE',
    PUBLIC = 'PUBLIC',
    BACKOFFICE = 'BACKOFFICE'
}

export enum ParamKey {
    JOB = 'job',
    CUSTOMER = 'customer',
    ORGANIZATION = 'organization',
    PROPERTY = 'property',
    ESTIMATE = 'estimate',
    ESTIMATES = 'estimate',
    ASSETS = 'asset',
    ASSET = 'asset',
    INVOICE = 'invoice',
    SERVICE_CONTRACTS = 'service_contract',
    SERVICE_CONTRACT = 'service_contract',
    PRODUCTS = 'product',
    REQUEST = 'request',
    PROJECT = 'project'
}

export enum ModuleUidKey {
    JOB = 'job_uid',
    CUSTOMER = 'customer_uid',
    ORGANIZATION = 'organization_uid',
    PROPERTY = 'property_uid',
    ESTIMATE = 'estimate_uid',
    ESTIMATES = 'estimate_uid',
    ASSETS = 'asset_uid',
    ASSET = 'asset_uid',
    INVOICE = 'invoice_uid',
    SERVICE_CONTRACTS = 'contract_uid',
    SERVICE_CONTRACT = 'contract_uid',
    PRODUCTS = 'product_uid',
    PROJECT = 'project_uid'
}
